import {
  CREATE_SETTING,
  SUPPORT_CREATE,
  VIEW_SETTING,
  ACCOUNT_SETTING,
  SETTING_PRIVACY_POLICY_VIEW,
  SETTING_TERMS_CONDTION_VIEW,
  SETTING_TERMS_CONDTION_EDIT,
  SETTING_PRIVACY_POLICY_EDIT
} from "./types";

export const supportCreate = (data, onSuccess, onError) => {
  return {
    type: SUPPORT_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const viewSetting = (onSuccess, onError) => {
  return {
    type: VIEW_SETTING,
    onSuccess,
    onError,
  };
};

export const createSetting = (order_validity, onSuccess, onError) => {
  return {
    type: CREATE_SETTING,
    order_validity,
    onSuccess,
    onError,
  };
};

export const settingsAccountDispatch = (onSuccess, onError) => {
  return {
    type: ACCOUNT_SETTING,
    onSuccess,
    onError,
  };
};

export const settingsPrivacyPolicyView = (onSuccess, onError) => {
  return {
    type: SETTING_PRIVACY_POLICY_VIEW,
    onSuccess,
    onError,
  };
};

export const termsConditionsview = (onSuccess, onError) => {
  return {
    type: SETTING_TERMS_CONDTION_VIEW,
    onSuccess,
    onError,
  };
};

export const privacyPolicyEdit = (data, onSuccess, onError) => {
  return {
    type: SETTING_PRIVACY_POLICY_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const termsConditionEdit = (data, onSuccess, onError) => {
  return {
    type: SETTING_TERMS_CONDTION_EDIT,
    data,
    onSuccess,
    onError,
  };
};
